<div class="clinic-welcome">
  <div class="clinic-welcome__backdrop" aria-hidden="true">
    <span class="clinic-welcome__orb clinic-welcome__orb--one"></span>
    <span class="clinic-welcome__orb clinic-welcome__orb--two"></span>
    <span class="clinic-welcome__orb clinic-welcome__orb--three"></span>
  </div>

  @if (loading()) {
    <mat-progress-spinner
      diameter="44"
      mode="indeterminate"
      strokeWidth="4"
    ></mat-progress-spinner>
  } @else if (clinic(); as clinicData) {
    <div class="clinic-welcome__card">
      <div class="clinic-welcome__avatar">
        @if (clinicData.logo?.url) {
          <img
            [src]="clinicData.logo?.url"
            [alt]="clinicData.name"
            class="clinic-welcome__logo"
          />
        } @else {
          <mat-icon class="clinic-welcome__avatar-icon">local_hospital</mat-icon>
        }
      </div>

      <h1 class="clinic-welcome__name">{{ clinicData.name }}</h1>

      @if (clinicAddress(clinicData) || clinicPhone(clinicData)) {
        <div class="clinic-welcome__contact">
          @if (clinicAddress(clinicData)) {
            <p class="clinic-welcome__detail">
              <mat-icon class="clinic-welcome__detail-icon">location_on</mat-icon>
              <span>{{ clinicAddress(clinicData) }}</span>
            </p>
          }

          @if (clinicPhone(clinicData)) {
            <p class="clinic-welcome__detail">
              <mat-icon class="clinic-welcome__detail-icon">call</mat-icon>
              <span>{{ clinicPhone(clinicData) }}</span>
            </p>
          }
        </div>
      }
    </div>
  }
</div>
